// Placeholder messages
export const ADD_CATEGORY_MESSAGE = 'Добавьте хотя бы одну категорию';
export const ADD_FILLERTYPE_MESSAGE = 'Добавьте хотя бы один тип наполнителя';
export const ADD_FABRICTYPE_MESSAGE = 'Добавьте хотя бы один тип ткани';
export const ADD_FILLERTYPE_AND_CATEGORY_MESSAGE = 'Добавьте хотя бы одну категорию и один тип наполнителя';
export const ADD_FABRICTYPE_AND_CATEGORY_MESSAGE = 'Добавьте хотя бы одну категорию и один тип ткани';
export const NO_PRODUCTS_MESSAGE = 'Товаров нет';
export const NO_TYPESOFFILLER_MESSAGE = 'Нет типов наполнителя';
export const NO_TYPESOFFABRIC_MESSAGE = 'Нет типов ткани';
export const NO_CATEGORIES_MESSAGE = 'Нет категорий';
export const NO_FILTERED_RESULTS = 'По заданному фильтру нет товаров';
export const NO_DISCOUNTED_PRODUCTS = 'Нет акционных товаров';
export const NO_PRODUCTS = 'Нет товаров';
export const NO_PRODUCTS_IN_CART = 'В корзине пока пусто';
export const NO_ORDERS = 'Нет заказов';
export const NO_USERS = 'Нет пользователей';
export const NO_PROMOCODES_MESSAGE = 'Промо-коды отсутствуют';
export const DELETE_PROMOCODE_ALERT_MESSAGE = 'Нельзя удалить промо-код, уже использованный хотя бы раз';
export const FETCH_PROMO_ERROR_MESSAGE = 'Не удалось загрузить промо-коды';
export const CREATE_PROMO_ERROR_MESSAGE = 'Не удалось создать промо-код';
export const UPDATE_PROMO_ERROR_MESSAGE = 'Не удалось обновить промо-код';
export const DELETE_PROMO_ERROR_MESSAGE = 'Не удалось удалить промо-код';

// Alert messages
export const DELETE_CATEGORY_ALERT_MESSAGE = 'Сначала удалите все товары из категории';
export const DELETE_FILLERTYPE_ALERT_MESSAGE = 'Сначала удалите все товары с типом наполнителя';
export const DELETE_FABRICTYPE_ALERT_MESSAGE = 'Сначала удалите все товары с типом ткани';
export const ADDED_TO_WISHLIST = 'Товар добавлен';
export const REMOVED_FROM_WISHLIST = 'Товар удален из избранного';
export const LINK_IS_COPIED = 'Ссылка скопирована';
export const GO_TO_WISHLIST = 'В избранное';
export const GO_TO_CART = 'В корзину';
export const ADD_TO_WISHLIST = 'В избранное';
export const REMOVE_FROM_WISHLIST = 'В избранном';
export const PRODUCT_ADDED_TO_CART = 'Товар добавлен';

// Category slice error messages
export const FETCH_CATEGORIES_ERROR_MESSAGE = 'Не удалось загрузить категории. Попробуйте позже';
export const CREATE_CATEGORY_ERROR_MESSAGE = 'Не удалось создать категорию. Попробуйте позже';
export const UPDATE_CATEGORY_ERROR_MESSAGE = 'Не удалось обновить данные. Попробуйте позже';
export const DELETE_CATEGORY_ERROR_MESSAGE = 'Не удалось удалить категорию. Попробуйте позже';

// TypesOfFiller slice error messages
export const FETCH_TYPESOFFILLER_ERROR_MESSAGE = 'Не удалось загрузить типы наполнителя. Попробуйте позже';
export const CREATE_FILLERTYPE_ERROR_MESSAGE = 'Не удалось создать тип наполнителя. Попробуйте позже';
export const UPDATE_FILLERTYPE_ERROR_MESSAGE = 'Не удалось обновить данные. Попробуйте позже';
export const DELETE_FILLERTYPE_ERROR_MESSAGE = 'Не удалось удалить тип наполнителя. Попробуйте позже';

// TypesOfFabric slice error messages
export const FETCH_TYPESOFFABRIC_ERROR_MESSAGE = 'Не удалось загрузить типы ткани. Попробуйте позже';
export const CREATE_FABRICTYPE_ERROR_MESSAGE = 'Не удалось создать тип ткани. Попробуйте позже';
export const UPDATE_FABRICTYPE_ERROR_MESSAGE = 'Не удалось обновить данные. Попробуйте позже';
export const DELETE_FABRICTYPE_ERROR_MESSAGE = 'Не удалось удалить тип ткани. Попробуйте позже';

// Product slice error messages
export const FETCH_PRODUCTS_ERROR_MESSAGE = 'Не удалось загрузить товары. Попробуйте позже';
export const CREATE_PRODUCT_ERROR_MESSAGE = 'Не удалось создать товар. Попробуйте позже';
export const UPDATE_PRODUCT_ERROR_MESSAGE = 'Не удалось обновить данные. Попробуйте позже';
export const DELETE_PRODUCT_ERROR_MESSAGE = 'Не удалось удалить товар. Попробуйте позже';
export const ARTICLE_DUPLICATE_ERROR_MESSAGE = 'Артикул уже используется другим товаром';

// Common slice error messages
export const FETCH_ORDERS_ERROR_MESSAGE = 'Не удалось загрузить заказы. Попробуйте позже';
export const CREATE_ORDER_ERROR_MESSAGE = 'Не удалось оформить заказ. Попробуйте позже';

// Tooltip messages
export const NO_WAY_TO_CHANGE_THIS_PRODUCT = 'Этот товар нельзя редактировать или удалить. Чтобы попробовать данный функционал добавьте собственный товар';
